import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<Conversation>('PUT', `/api/v2/conversation/${conversationId}/read`);
